import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const Svg4Squares1Turned = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.9999 3.88031L14.1224 6.00281L11.9999 8.12531L9.87738 6.00281L11.9999 3.88031ZM6.25488 4.24031V7.24031H3.25488V4.24031H6.25488ZM13.7549 11.7403V14.7403H10.7549V11.7403H13.7549ZM6.25488 11.7403V14.7403H3.25488V11.7403H6.25488ZM11.9999 1.75781L7.75488 5.99531L11.9999 10.2403L16.2449 5.99531L11.9999 1.75781ZM7.75488 2.74031H1.75488V8.74031H7.75488V2.74031ZM15.2549 10.2403H9.25488V16.2403H15.2549V10.2403ZM7.75488 10.2403H1.75488V16.2403H7.75488V10.2403Z",
		fill: "#1D1D1D"
	})
});
export default Svg4Squares1Turned;
